import { portalsReducer } from './portals.reducer'
export * from './portals.thunks'
export * from './portals.actions'

export default portalsReducer
